const RESET_NEW_PASSWORD_SEND = 'RESET_NEW_PASSWORD_SEND';
const RESET_NEW_PASSWORD_SET_SENT = 'RESET_NEW_PASSWORD_SET_SENT';


const resetNewPasswordSend = (password) => ({
  type: RESET_NEW_PASSWORD_SEND,
  payload: password
});

const resetNewPasswordSetSent = (sent) => ({
  type: RESET_NEW_PASSWORD_SET_SENT,
  payload: sent
});

export {
  RESET_NEW_PASSWORD_SEND,
  RESET_NEW_PASSWORD_SET_SENT,
  resetNewPasswordSend,
  resetNewPasswordSetSent
};
